import styled from 'styled-components';
import { types } from '../../../libs/themes';

export const ModalHeader = styled.div<{ $isMobile?: boolean }>`
    display: flex;
    align-items: ${({ $isMobile }) => $isMobile ? 'flex-start' : 'center'};
    justify-content: space-between;
    padding: ${({ $isMobile }) => $isMobile ? '12px 16px 8px' : '16px 48px 16px 50px'};
    gap: ${({ $isMobile }) => $isMobile ? '6px' : '16px'};
    flex-wrap: wrap;
    flex-direction: ${({ $isMobile }) => $isMobile ? 'column' : 'row'};
`;

export const BackArrow = styled.span`
  cursor: pointer;
  ${types.body.secondaryTitle}
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.cardText};
`;

export const TitleContainer = styled.span<{ $isMobile?: boolean }>`
    ${({ $isMobile }) => $isMobile ? 'font-size: 20px; font-weight: 700;' : types.headers.main42}
    color: ${({ theme }) => theme.cardText};
`;

export const VideoCount = styled.span`
   ${types.headers.itemMedium}
  color: ${({ theme }) => theme.cardTextAlt};
  margin-left: 10px;
`;

export const ScrollableContent = styled.div`
  height: 100vh;
  overflow-y: auto;
  padding: 0px 30px;
`;

export const MediaGrid = styled.div<{ $isMobile?: boolean }>`
  position: relative;
  margin-left: ${({ $isMobile }) => $isMobile ? '12px' : '20px'};
  margin-right: ${({ $isMobile }) => $isMobile ? '12px' : '20px'};
  margin-top: 20px;
  display: grid;
  grid-template-columns: ${({ $isMobile }) => $isMobile ? '1fr' : 'repeat(auto-fill, minmax(350px, 1fr))'};
  gap: ${({ $isMobile }) => $isMobile ? '12px' : '20px'};
`;
export const MobileHeaderTopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: space-between;
`;

export const MobileFilterRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const EmptyStateMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  padding: 0 10px;
  color: ${({ theme }) => theme.cardText};
`;

export const VideoCountMobile = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.cardTextAlt};
  margin-left: 8px;
`;